<template>
  <div class="w-full">
    <div class="flex border-b border-line w-full">
      <button
        v-for="tab in tabs"
        :key="tab.id"
        class="flex-1 text-center py-3 font-medium text-base transition-colors duration-200 relative bg-transparent outline-none"
        :class="[activeTab === tab.id ? 'text-primary' : 'text-ink-mute hover:text-primary']"
        @click="setActiveTab(tab.id)"
      >
        {{ tab.label }}
        <span
          v-if="activeTab === tab.id"
          class="absolute left-0 bottom-0 w-full h-0.5 bg-primary rounded transition-all duration-200"
        ></span>
      </button>
    </div>
    <div class="py-4">
      <slot :name="activeTab"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, defineProps, defineEmits } from 'vue';

interface Tab {
  id: string;
  label: string;
}

const props = defineProps<{
  tabs: Tab[];
  initialTab?: string;
}>();

const emit = defineEmits<{
  (e: 'change', tabId: string): void;
}>();

const activeTab = ref(props.initialTab || (props.tabs.length ? props.tabs[0].id : ''));

function setActiveTab(tabId: string) {
  activeTab.value = tabId;
  emit('change', tabId);
}
</script>

<style scoped>
button {
  position: relative;
  border: none;
  background: none;
  cursor: pointer;
}
</style>
